import {
  Configuration,
  DefaultApi,
} from '@quipper/k12-frontend-darklaunch-v2-client-js-sdk';

// 現在使用中のキーがないのでダミーのキーを設定
export type DarklaunchV2Key =
  'dummy-dv2-key' | 'enable-school-comm-fp-shingaku-preview';

export const darklaunchV2Client = new DefaultApi(
  new Configuration({
    basePath: import.meta.env.VITE_DARKLAUNCH_V2_API_URL,
  }),
);
